module.exports = require('./dist')



//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-theme/index.js
// module id = 215
// module chunks = 0